// Avantages en nombre limité (D-131) : les phrases du nombre limité, côté membres, bureau et partenaire (maquettes a2, a3).
// Neutres (ni « tu » ni « vous ») : elles servent aussi dans l'espace du partenaire.

/** Un avantage épuisé, côté membres (maquette a3) : « Les 2 sont partis : merci à Garage Saint-Jean ! ». */
export function goneText(p: { stock: number | null; partner_name: string | null }): string {
  const n = p.stock ?? 0;
  if (p.partner_name) return n > 1 ? `Les ${n} sont partis : merci à ${p.partner_name} !` : `Il est parti : merci à ${p.partner_name} !`;
  return n > 1 ? `Les ${n} sont partis.` : 'Il n’y en avait qu’un : il est parti.';
}
/** Côté bureau (maquette a2) : « 3 partis sur 5 · plus que 2 ». */
export function stockLine(used: number, stock: number): string {
  if (used <= 0) return `Aucun parti pour l’instant · ${stock} en tout`;
  return `${used} ${used > 1 ? 'partis' : 'parti'} sur ${stock} · plus que ${Math.max(stock - used, 0)}`;
}
/** « Terminé : les 2 sont partis le 24 octobre. » */
export function endedLine(stock: number, at: string): string {
  const day = new Date(at).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long' });
  return `Terminé : ${stock > 1 ? `les ${stock} sont partis` : 'il est parti'} le ${day}.`;
}
